import React from "react";
import { Container } from "reactstrap";
import DashboardNav from "../Dashboard/DashboardMenu/DashboardNav";

const DashboardLayout = ({ children, selectedValue, setSelectedValue, setLocationData,locationData }) => {
  return (
    <Container fluid className="dashboard">
      <DashboardNav
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
        setLocationData= {setLocationData}
        locationData={locationData}
      />

      <div>{children}</div>
    </Container>
  );
};

export default DashboardLayout;
